import { levelOmitsPlayFormat } from "./enums";
import type { ContentImportItemDto } from "./types";

const QUESTION_POOL_MODALITIES = new Set([
  "LEVEL_MODALITY_QUIZ",
  "LEVEL_MODALITY_TREASURE_HUNT",
  "LEVEL_MODALITY_TOWER_CLIMB",
]);

export function normalizeLevelImportItem(
  item: ContentImportItemDto
): ContentImportItemDto {
  const next = { ...item };

  if (next.modality === undefined) {
    next.modality = "LEVEL_MODALITY_QUIZ";
  }

  if (next.difficulty === undefined) {
    next.difficulty = "LEVEL_DIFFICULTY_NORMAL";
  }

  if (levelOmitsPlayFormat(next.modality)) {
    delete next.playFormat;
  } else if (next.playFormat === undefined) {
    next.playFormat = "PLAY_FORMAT_SOLO";
  }

  const modality = typeof next.modality === "string" ? next.modality : "";
  if (!QUESTION_POOL_MODALITIES.has(modality)) {
    delete next.questionDifficulties;
  } else if (
    !Array.isArray(next.questionDifficulties) ||
    next.questionDifficulties.length === 0
  ) {
    delete next.questionDifficulties;
  }

  delete next.activityType;
  delete next.config;
  delete next.title;
  delete next.description;
  delete next.body;
  delete next.media;
  delete next.feedbacks;

  return next;
}
